class ListSelectorElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener("subnav-select", this);
  }

  handleEvent(e) {
    if (e.type === "subnav-select") {
      const { id } = e.detail;
      if (id) {
        const items = [...this.querySelectorAll("[id]")];
        for (const item of items) {
          item.toggleAttribute("hidden", item.id !== id);
        }
      }
    }
  }
}

customElements.define("list-selector", ListSelectorElement);
